import { render, staticRenderFns } from "./ReviewConfirm.vue?vue&type=template&id=64ca04ca&scoped=true&"
import script from "./ReviewConfirm.vue?vue&type=script&lang=js&"
export * from "./ReviewConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ReviewConfirm.vue?vue&type=style&index=0&id=64ca04ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ca04ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VIcon,VSubheader})
